"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// A simple email regular expression that is very inclusive
// such that we won't accidently miss emails
// eslint-disable-next-line import/prefer-default-export
var emailRegex = exports.emailRegex = /[a-zA-Z0-9][A-Za-z0-9!#$%&'*+/=?^`{|}~._-]*@(?!([a-zA-Z0-9]*\.[a-zA-Z0-9]*\.[a-zA-Z0-9]*\.))(?:[A-Za-z0-9](?:[a-zA-Z0-9-]*[A-Za-z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/g;


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/regexUtils.js
 ** module id = 1407
 ** module chunks = 0
 **/